import {gql, useLazyQuery} from "@apollo/client";

const REQUEST_SIGNIN_BY_EMAIL_VERIFICATION = gql`
    query requestSigninByEmailVerification($email: String!, $password: String!, $device_token: String) {
        requestSigninByEmailVerification(email: $email, password: $password, device_token: $device_token) {
            loginSessionToken
            expiresAt
            phoneLastFour
        }
    }
`;

export default function useRequestPhoneCode() {
    return useLazyQuery(REQUEST_SIGNIN_BY_EMAIL_VERIFICATION, {
        fetchPolicy: 'network-only',
    });
}
